import React, { useState } from 'react';
import { toast } from 'react-toastify';
import useMain from '../../../../hooks/useMain';
import http from '../../../../services/httpService';
import { paginate } from '../../../../utils/paginate';
import Image from '../../../common/image';
import Pagination from '../../../common/pagination';
import TokenTable from '../../ingredients/tokenTable';
import WalletRequestModal from '../../ingredients/walletRequestModal';

const TokenPurchases = () => {
	const pageSize = 15;
	const { userData, onUserDataChanged, theme } = useMain();
	const { token } = userData;
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [modalShow, setModalShow] = useState(false);
	const [currentTOKEN, setCurrentTOKEN] = useState(null);
	const [response, setResponse] = useState(null);

	const activeTokens = token.filter((d) => d.isActive);
	const data = paginate(activeTokens, currentPage, pageSize);

	const handleClick = async (TOKEN) => {
		setCurrentTOKEN(TOKEN);
		setModalShow(true);
	};

	const handleRequestSubmit = async (formData) => {
		try {
			setIsLoading(true);
			const { data } = await http.tokenRequestWallet({
				...formData,
				...{ tokenId: currentTOKEN._id },
			});
			onUserDataChanged(data.data);
			setResponse(data.response);
			toast.success(data.message);
		} catch (ex) {
			console.log(ex);
			if (ex && ex.response && ex.response.data) return toast.error(ex.response.data);
			if (ex && ex.message) return toast.error(ex.message);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<div className='card myCards'>
				<div className='row p-4'>
					<div className='col-md-10 offset-md-1 col-12'>
						<div className='fs-1 pt-4 text-center'>Purchases Table</div>
						<div className='fs-3 pb-5 text-center'>
							Active Purchases: {activeTokens.length}
						</div>
						{activeTokens.length > 0 ? (
							<div className='pb-5'>
								<TokenTable
									data={data}
									onClick={handleClick}
									isLoading={isLoading}
								/>
								<Pagination
									customClass='mt-1 myPagination'
									activeClass='myActive'
									totalCount={activeTokens.length}
									pageSize={pageSize}
									currentPage={currentPage}
									onPageChange={setCurrentPage}
								/>
							</div>
						) : (
							<div className='text-center my-5'>
								<Image
									height='180px'
									fileName={`icons/noData_${theme}.webp`}
								/>
								<h4 className='mt-4'>There are no purchases.</h4>
							</div>
						)}
					</div>
				</div>
			</div>
			<WalletRequestModal
				show={modalShow}
				onClose={() => {
					setModalShow(false);
					setCurrentTOKEN(null);
					setResponse(null);
				}}
				hasSP={userData.hasSP}
				currentDEFI={currentTOKEN}
				onRequestSubmit={handleRequestSubmit}
				isLoading={isLoading}
				response={response}
			/>
		</>
	);
};

export default TokenPurchases;
